import React from 'react';
import './PricingComparison.css';

const PricingComparison = ({ onUpgrade }) => {
  const renderAccess = (value) => {
    const unavailable = value === 'Not included';
    return (
      <>
        <span className={`feature-status-icon ${unavailable ? 'unavailable' : 'available'}`} aria-hidden="true">
          {unavailable ? '✕' : '✓'}
        </span>
        {value}
      </>
    );
  };

  const features = [
    { name: 'Manual status lookup', free: 'One complimentary lookup', premium: 'Unlimited for your registered reference' },
    { name: 'Public decision statistics', free: 'Included', premium: 'Included' },
    { name: 'Decision email alerts', free: 'Not included', premium: 'Included' },
    { name: 'Browser notifications', free: 'Not included', premium: 'Optional; enable on each device' },
    { name: 'All 13 planning tools', free: 'Not included', premium: 'Included' },
    { name: 'Processing-time planning tool', free: 'Not included', premium: 'Included; not an official deadline' },
    { name: 'Profile-readiness checklist', free: 'Not included', premium: 'Included; not an approval prediction' }
  ];
  return (
    <div className="pricing-comparison-section">
      <div className="comparison-header">
        <h2>Compare Free Vs Premium Plan</h2>
        <p className="comparison-subtitle">See what you unlock with your premium upgrade, including all 13 premium tools</p>
      </div>
      <div className="comparison-table-wrapper">
        <table className="comparison-table">
          <thead><tr>
            <th className="feature-column" scope="col">Feature</th>
            <th className="plan-column free-column" scope="col">Free Access</th>
            <th className="plan-column premium-column" scope="col">
              <div className="premium-header">
                <span className="premium-badge">One-time payment</span>
                <span className="premium-title">Premium ₹349</span>
              </div>
            </th>
          </tr></thead>
          <tbody>{features.map((feature) => (
            <tr key={feature.name}>
              <th className="feature-name" scope="row">{feature.name}</th>
              <td className="feature-value free-value">{renderAccess(feature.free)}</td>
              <td className="feature-value premium-value">{renderAccess(feature.premium)}</td>
            </tr>
          ))}</tbody>
        </table>
      </div>
      <div className="value-stack">
        <h3>One purchase, no recurring charge</h3>
        <p>Monitoring for your registered visa references, decision emails and all 13 premium planning tools.</p>
        <p>Browser alerts require permission and enrollment on each device. Alert timing depends on publication, processing and provider delivery.</p>
        <div className="value-your-price">
          <div className="your-price-label">One-time price:</div>
          <div className="your-price-amount">₹349</div>
        </div>
      </div>
      <div className="comparison-cta">
        <button className="btn-primary btn-shimmer comparison-cta-btn" onClick={onUpgrade}>
          Upgrade to Premium for ₹349 – Alerts + 13 Tools →
        </button>
        <p className="cta-guarantee">One-time, non-refundable purchase. Please read our <a href="/refund">refund policy</a> before paying. Payments processed by PayU.</p>
      </div>
    </div>
  );
};
export default PricingComparison;
